// Utility function to create page URLs
export const createPageUrl = (pageName) => {
  // Convert page name to kebab-case and add /ats prefix
  const kebabCase = pageName
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .toLowerCase();
  return `/ats/${kebabCase}`;
};

// Additional utility functions can be added here
export const formatDate = (date) => {
  if (!date) return '';
  return new Date(date).toLocaleDateString();
};

export const formatCurrency = (amount) => {
  if (!amount) return '$0';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
};
